
import {Constants,ArrayUtil} from '../Constants';

import { CoordGeodetic } from '../../service/coord-helper.service';
import { FdmPlugin, FdmPluginInterface } from './plugins';
import { Transform } from '4d-mapper';


const Cesium = (<any>window).Cesium;


export class FlightpathHandler extends FdmPlugin implements FdmPluginInterface {

    debug:boolean = Constants.debug_off;

    static meta = {
        label: 'PLUGINS.FLIGHTPATH.LABEL',
        name: 'flightpath-handler',
        translator: 'PLUGINS.FLIGHTPATH',
        tooltip: 'PLUGINS.FLIGHTPATH.TOOLTIP',
        
        category: FdmPlugin.category.beta,
        types: [ FdmPlugin.types.coordController ]
    };

    show:boolean = true;

    coords:CoordGeodetic[] = null;

    maxHeight:number = 0;
    minHeight:number = 99999999;

    coordHelper:any = null;

    init() {
        this.coordHelper = this.services.coordHelper;
    }

    updateCoordsFromPhotos ( photos:Transform[] ) {

        let points:CoordGeodetic[] = [];

        photos.forEach ( p => {
            
            let c = null;
            if ( c = p['canonicalCoords'] ) {
                points.push ( c );
                if ( c.height && c.height > this.maxHeight ) {
                    this.maxHeight = c.height;
                }
                if ( c.height && c.height < this.minHeight ) {
                    this.minHeight = c.height;
                }
            }
        });

        this.coords = points;

        this.updateCoords ();

    }

    updateCoords ( coords:CoordGeodetic[] = null ) {

        if ( coords ) {
            this.coords = coords;
        }

        this.wipe();

        if ( this.coords && this.coords.length > 0 ) {
            this.entity ( 'primary', this.services.mapService.viewer.entities.add ({
                name: 'flightpath : polyline',
                show: this.show,
                polyline: {
                    positions: this.coordHelper.toCartesians ( this.coords ),
                    width: 6,
                    material: new Cesium.PolylineDashMaterialProperty({
                        color: Cesium.Color.WHITE.withAlpha(0.5),
                        gapColor: Cesium.Color.WHITE.withAlpha(0.7),
                        dashLength: 12,
                    }),
                }
            }));
        
            this.showHide();
        }
        
    }

}
